import { render, staticRenderFns } from "./SendSms.vue?vue&type=template&id=b00f1b9c&scoped=true&"
import script from "./SendSms.vue?vue&type=script&lang=js&"
export * from "./SendSms.vue?vue&type=script&lang=js&"
import style0 from "./SendSms.vue?vue&type=style&index=0&id=b00f1b9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00f1b9c",
  null
  
)

export default component.exports